


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'ConfirmCampaignUpdateDialog',
})
export default class ConfirmCampaignUpdateDialog extends Vue {
  @Prop({ required: true }) showDialog!: boolean;

  closeDialog() {
    this.$emit('close');
  }

  confirmUpdate() {
    this.$emit('confirm');
  }
}
